/**
 * Default name of a follow-up successor goal (every mode except "custom",
 * whose request may name its goals). One rule for createFollowup and the
 * advisor dialog's "Creates N goal(s)" preview, so the two cannot disagree.
 */

/** Prefix-collapsing: a follow-up of "Followup - X" is "Followup - X", never "Followup - Followup - X". */
export const followupName = (base: string) => `Followup - ${base.replace(/^(Followup - )+/, "")}`;

export type FollowupNamingItem = { type: "account" | "agreement"; name: string };

/**
 * - The goal the successor descends from (the chosen items' primary source
 *   goal) names it.
 * - Without one, a single chosen item names it.
 * - Otherwise the family is a savings plan with its target accounts
 *   (QL-567): named after the family's plan — also when the plan itself is
 *   not followed up (not selected, or not eligible) — else the first item.
 */
export function followupGoalName(input: {
  sourceGoalName: string | null;
  /** The items followed up into this goal (non-empty). */
  chosen: readonly FollowupNamingItem[];
  /** Every item of the selection-context family the chosen items belong to. */
  family: readonly FollowupNamingItem[];
}): string {
  if (input.sourceGoalName) return followupName(input.sourceGoalName);
  if (input.chosen.length === 1) return followupName(input.chosen[0]!.name);
  const named = input.family.find((i) => i.type === "agreement") ?? input.chosen[0]!;
  return followupName(named.name);
}
